import { DataTableCol } from "../../../components/tables/types";

export const alertListDataGridCols: DataTableCol[] = [
    {
        title: 'Batch Name',
        control: 'batchName',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Content',
        control: 'content',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Status',
        control: 'status',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Actions',
        control: 'both',
        sortable: false,
        isEdit: true,
        isDelete: true,
        canShowColumn: true
    },
];